import { checkEnvironment } from '@saviynt/common';

const getRequestDetailsUrl = (userName, requestId) => {
  const { GATEWAY_API_URL } = checkEnvironment();

  return `${GATEWAY_API_URL}/api/pam/requests/${requestId}?username=${userName}`;
};

export default getRequestDetailsUrl;
